export const Path = {
  scheduler: "/scheduler",
  toDoList: "/todolist",
  addTask: "/todoList/addtask",
  editTask: "/todoList/edittask",
  clock: "/clock",
  prescription: "/prescription",
  addPrescription: "/prescription/addtask",
  editPrescription: "/prescription/edittask",
  signUp: "/signup",
  login: "/login",
  resetPassword: "/resetPassword/:query",
  forgotPassword: "/forgotPassword",
  home: "/",
};
